export const SET_IMAGE = 'SET_IMAGE'